import { areaSchema } from "@/schemas/area-schema";

const extractCordinates = (coords: any): number[][] => {
	if (typeof coords[0] === "number") {
		return [coords];
	}

	return coords.flatMap(extractCordinates);
};

export const fetchArea = async (): Promise<
	| {
			isLoading: boolean;
			error: null;
			data: {
				coords: number[][];
				id: string;
			}[];
	  }
	| {
			isLoading: boolean;
			error: string;
			data: never[];
	  }
> => {
	try {
		const res = await fetch(
			"https://kuwait.exelys.io/kuwait_warning/areas.json",
		);

		if (!res.ok) {
			throw new Error("Une erreur est survenue");
		}

		const data = await res.json();

		const validatedData = areaSchema.parse(data);

		const format = validatedData.features.map((feature) => {
			const featuresCoords = feature.geometry.coordinates[0].flatMap((feat) => {
				return extractCordinates(feat);
			});

			return {
				coords: featuresCoords,
				id: feature.properties.geometry_id,
			};
		});

		return {
			isLoading: false,
			error: null,
			data: format,
		};
	} catch {
		return {
			isLoading: false,
			error: "Une erreur est survenue",
			data: [],
		};
	}
};
